import { styled } from "@mui/material";
import { APP_COLOR, APP_HOVER_COLOR, FONT_FAMILY } from "../../theme";

export const styles = {
  container: {
    textAlign: "center",
    fontWeight: "bold",
    paddingTop: "30px",
    alignItems: "center",
    marginTop: "10px",
  } as const,
  button: {
    width: "200px",
    marginBottom: "25px",
    textTransform: "none",
    color: "black",
    backgroundColor: APP_COLOR,
    borderColor: APP_COLOR,
    "&:hover": {
      borderColor: APP_COLOR,
      backgroundColor: APP_HOVER_COLOR,
    },
    fontFamily: FONT_FAMILY,
    height: 40,
    marginTop:"30px",
    "&.Mui-disabled": {
      color: "B1D1F2",
      backgroundColor: APP_HOVER_COLOR,
    },
  } as const,
  disableButton: {
    width: "200px",
    marginBottom: "25px",
    backgroundColor: "gray",
  },
  buttonContainer: {} as const,
  downloadSkipButton: {
    margin: "10px 10px 30px",
    backgroundColor: APP_COLOR,
    color: "black",
    width: "200px",
    fontFamily: FONT_FAMILY,
    padding: 10,
    fontSize: 15,
    textTransform: "none",
  } as const,
};


export const MetamaskInstructionContainer = styled('p')(({ theme }) => ({
  width: "300px",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));